<template>
  <CRow>
    <CCol>
      <CCard style="margin-top: 20px">
        <CCardBody>
          <!-- <JsonCSV
            color="primary"
            class="btn btn-default mb-2 clr"
            :data="tableData"
            name="User-list.csv"
          >
            Download CSV (This is a slot)
          </JsonCSV> -->
          <CButton
            block
            color="success"
            style="width: 120px"
            @click="myModal = true"
          >
            <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
          >
          <CDataTable
            :items="tableData"
            :fields="fields"
            column-filter
            table-filter
            items-per-page-select
            :items-per-page="10"
            hover
            sorter
            pagination
          >
            <template #image="{ item }">
              <td>
                <img :src="item.image" style="width: 150px; height: 150px" />
              </td>
            </template>
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="deleteRoute(item, index)"
                >
                  Delete
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CModal title="Add Banner" :show.sync="myModal">
            <CCol col="12" md="12">
              <CCard>
                <CCardBody>
                  <div>
                    <p>Upload an image to Firebase:</p>
                    <button
                      @click="onUpload"
                      v-if="uploadbtn"
                      class="btn btn-info btn-block"
                      style="float: right; width: auto"
                    >
                      Upload
                    </button>
                    <input
                      type="file"
                      @change="previewImage"
                      accept="image/*"
                    />
                  </div>
                  <div>
                    <p>
                      Progress: {{ uploadValue.toFixed() + "%" }}
                      <progress
                        id="progress"
                        :value="uploadValue"
                        max="100"
                      ></progress>
                    </p>
                  </div>
                  <div v-if="imageData != null">
                    <img
                      class="preview"
                      :src="picture"
                      style="width: 300px; height: 300px"
                    />
                    <br />
                  </div>
                </CCardBody>
              </CCard>
            </CCol>

            <template #footer>
              <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
              <CButton color="success" @click="savepromo()">Save</CButton>
            </template>
          </CModal>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();
import moment from "moment";
import { getStyle, hexToRgba } from "@coreui/utils/src";
import Userchart from "./userchart.vue";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    Apexchart,
    Userchart,
    JsonCSV,
    DatePicker,
  },
  name: "AdvancedTables",
  data() {
    return {
      uploadbtn: false,
      hidechart: false,
      myModal: false,
      tableData: [],
      bannernumber:1,
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        //  {
        //    label: "Banner No",
        //   key: "bannerNumber",
        //   sortable: true,
        // },
        {
          label: "Banner",
          key: "image",
          sortable: true,
          _style:'text-align: initial;'
        },

       
        // {
        //    label: "field4",
        //   key: "field4",
        //   sortable: true,
        // },
        {
          key: "Action",
          sortable: true,
        },
      ],
      value1: [],
      details: [],
      collapseDuration: 0,
      imageData: null,
      picture: null,
      uploadValue: 0,
    };
  },

  methods: {
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      this.uploadbtn = true;
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`banner/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    savepromo() {
      var date = new Date();
      console.log("this.tableData.length",this.bannerlength)
      if(this.bannerlength == 0){
        this.bannernumber=1;
        console.log("zero",this.bannernumber)
      }else{
        this.bannernumber=this.bannernumber+this.bannerlength;
        console.log("one",this.bannernumber)
      }
      db.collection("bannerPictures")
        .add({
          date: date,
          picture: this.picture,
          bannerNumber: this.bannernumber
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          
          this.myModal = false;
          this.picture = "";
          window.location.reload();
          
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("bannerPictures")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
         
            let backenddate =
              doc.data().date != null
                ? moment(doc.data().date.seconds * 1000).format("DD-MMM-YYYY")
                : "";
            this.tableData.push({
              id: doc.id,
              image: doc.data().picture,
              date: backenddate,
              bannerNumber:doc.data().bannerNumber
            });
              
          });
         this.bannerlength=this.tableData.length;
         console.log("this.bannerlength",this.bannerlength)
        });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("bannerPictures")
        .doc(this.documentId)
        .delete()
        .then(() => {
          // console.log("Document successfully deleted!");
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.gettokens();
  },
};
</script>
<style >
.clr {
  color: #fff !important;
  background-color: #321fdb !important;
}
.swal2-cancel {
  margin: 10px !important;
}
</style>